import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'
import { SuccessMessage } from 'helpers/messages'

/**
 * Service to update admin user details
 */
export const updateAdminDetailsService = (userData) => {
  return axiosInstance(METHOD_TYPES.put, '/admins/update', userData, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.adminDetailsUpdated
  })
}

export const updatePasswordService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/admins/change-password', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.changePassword
  })
}

// Get all operators
export const getAllOperatorsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/admins/list', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

// Create new operator
export const createOperatorService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.post, '/admins/create', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage
  })
}

// Update operator status
export const updateOperatorStatusService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.put, '/admins/update-status', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage
  })
}

// Reset operator password
export const resetOperatorPasswordService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.post, '/admins/reset-operator-password', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage
  })
}

// Get all roles
export const getRolesService = () => {
  return axiosInstance(METHOD_TYPES.get, '/admins/roles', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}

// Get role permissions
export const getRolePermissionsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/admins/role-permissions', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

// Update role permissions
export const updateRolePermissionsService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.put, '/admins/role-permissions', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage
  })
}

export const getAdminDetailsService = () => {
  return axiosInstance(METHOD_TYPES.get, '/admins/details', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page
  })
}
// Get all IPs
export const getAllIpWhitelistService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/ip-whitelist/list', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    handlerEnabled: true,
    params
  })
}

// Create IP
export const createIpWhitelistService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.post, '/ip-whitelist/create', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    handlerEnabled: true,
    successMessage
  })
}

// Update IP status
export const updateIpWhitelistService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.put, '/ip-whitelist/update', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    handlerEnabled: true,
    successMessage
  })
}

// Delete/Restore IP
export const deleteIpWhitelistService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.put, '/ip-whitelist/delete', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    handlerEnabled: true,
    successMessage
  })
}
export const checkIpWhitelistService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/ip-whitelist/check', data, {
    server: microServices.USER_URL,
    handlerEnabled: true,
    loader: LOADER_HANDLER_TYPES.page
  })
}
// Create a New Role
export const createRoleService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.post, '/admins/roles/create', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage
  })
}

// Delete operator
export const deleteOperatorService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.delete, '/admins/delete', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage,
    params: data
  })
}

// Delete role
export const deleteRoleService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.delete, '/admins/roles/delete', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage,
    params: data
  })
}

export const updateOperatorRoleService = (data, successMessage) => {
  return axiosInstance(METHOD_TYPES.put, '/admins/update-role', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage
  })
}

export const getGameSettingsLogsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/games/settings-logs', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

export const getAuditLogsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/admins/audit-logs', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}
